module.exports = __webpack_public_path__ + "img/emoji-smile-upside-down.236f573d.svg";